var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.875,
    height: 62.5,
    viewBox: "1015 3188 46.875 62.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1037.205 3219.262c-.61-1.953-.599-5.725-.245-5.725 1.026 0 .928 4.505.245 5.725Zm-.208 5.762c-.94 2.466-2.112 5.286-3.467 7.654 2.234-.855 4.761-2.1 7.678-2.674-1.55-1.171-3.04-2.856-4.21-4.98Zm-11.487 15.234c0 .098 1.612-.659 4.26-4.907-.817.77-3.552 2.99-4.26 4.907Zm19.763-32.727h16.602v40.04a2.923 2.923 0 0 1-2.93 2.929h-41.015a2.923 2.923 0 0 1-2.93-2.93v-56.64a2.923 2.923 0 0 1 2.93-2.93h24.414v16.602a2.938 2.938 0 0 0 2.93 2.93Zm-.976 20.972c-2.442-1.49-4.065-3.54-5.213-6.567.55-2.259 1.416-5.689.757-7.837-.573-3.59-5.175-3.235-5.835-.83-.61 2.233-.048 5.383.99 9.399-1.417 3.37-3.504 7.886-4.981 10.474-.013 0-.013.012-.025.012-3.308 1.697-8.984 5.432-6.653 8.3.684.843 1.954 1.221 2.625 1.221 2.185 0 4.358-2.197 7.458-7.544 3.15-1.037 6.604-2.331 9.644-2.832 2.649 1.44 5.75 2.38 7.812 2.38 3.565 0 3.81-3.906 2.405-5.297-1.697-1.66-6.628-1.184-8.984-.88Zm16.724-27.686-11.963-11.963a2.927 2.927 0 0 0-2.076-.854h-.732v15.625h15.625v-.745a2.92 2.92 0 0 0-.854-2.063Zm-9.046 31.165c.5-.33-.305-1.453-5.225-1.099 4.53 1.929 5.225 1.099 5.225 1.099Z",
    fill: "#505050",
    fillRule: "evenodd",
    "data-name": "Icon awesome-file-pdf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PdfIcon.3ea5cba68ff18a0a61cd3e534ac4a9c2.svg";
export { ForwardRef as ReactComponent };